<template>
    <div class="tw:bg-white tw:rounded-xl">
        <BaseTable
            data-cy="abonados-table"
            :columns="columns"
            :data="abonados"
            :skeleton="loading"
            :skeleton-rows="5"
            empty-text="No hay abonados disponibles"
            :default-col-width="defaultColWidth"
        >
            <!-- Skeleton headers -->
            <template #skeleton-header-renovado>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-10 tw:mx-auto"></div>
            </template>
            <template #skeleton-header-numero>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-14 tw:mx-auto"></div>
            </template>
            <template #skeleton-header-origen>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-12"></div>
            </template>
            <template #skeleton-header-dni>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-10"></div>
            </template>
            <template #skeleton-header-nombre>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-14"></div>
            </template>
            <template #skeleton-header-email>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-12"></div>
            </template>
            <template #skeleton-header-acciones>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-28 tw:mx-auto"></div>
            </template>

            <!-- Skeleton rows -->
            <template #skeleton-renovado>
                <div class="tw:h-5 tw:w-5 tw:bg-gray-200 tw:rounded-full tw:mx-auto"></div>
            </template>
            <template #skeleton-numero>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-10 tw:mx-auto"></div>
            </template>
            <template #skeleton-origen>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-20"></div>
            </template>
            <template #skeleton-dni>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-24"></div>
            </template>
            <template #skeleton-nombre>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-3/4"></div>
            </template>
            <template #skeleton-email>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-1/2"></div>
            </template>
            <template #skeleton-acciones>
                <div class="tw:h-9 tw:w-28 tw:bg-gray-200 tw:rounded tw:mx-auto"></div>
            </template>

            <template #cell-renovado="{ row }">
                <div :class="['tw:h-3 tw:w-3 tw:rounded-full', getRenovadoClass(row.esta_renovado)]" :title="getRenovadoTitle(row.esta_renovado)"></div>
            </template>

            <template #cell-nombre="{ row }">
                <span class="tw:truncate">{{ row.name }} {{ row.surnames }}</span>
            </template>

            <template #cell-acciones="{ row, index }">
                <OptionsDropdownComponent
                    :options="getRowOptions(row)"
                    :force-open-down="index === 0"
                />
            </template>
        </BaseTable>
    </div>
</template>

<script setup>
    import BaseTable from '@/modules/admin/ui/table/BaseTable.vue'
    import OptionsDropdownComponent from '@/modules/admin/ui/OptionsDropdownComponent.vue'
    import { useAbonadoRowActions } from '@/composables/admin/abonados/useAbonadoRowActions'

    const props = defineProps({
        abonados: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        columns: {
            type: Array,
            required: true
        },
        listaId: {
            type: Number,
            default: null
        },
        teatro: {
            type: Object,
            default: () => ({})
        },
        permisos: {
            type: Object,
            default: () => ({})
        },
        configuracion: {
            type: Object,
            default: () => ({})
        },
        manager: {
            type: Object,
            default: () => ({})
        },
        defaultColWidth: {
            type: String,
            default: '120px'
        }
    })

    const emit = defineEmits(['enviar-abono', 'modificar-estado', 'show-modal'])

    const { getRowOptions } = useAbonadoRowActions(props, emit)

    function getRenovadoClass(value) {
        switch (value) {
            case 1:  return 'tw:bg-green-500'
            case 2:  return 'tw:bg-blue-500'
            default: return 'tw:bg-red-500'
        }
    }

    function getRenovadoTitle(value) {
        switch (value) {
            case 1:  return 'Renovado'
            case 2:  return 'En proceso'
            default: return 'No renovado'
        }
    }
</script>
